import { FC } from "react";
import classNames from "classnames";
import Translate from "../translate/Translate";

type Props = {
    wrapperClassName?: string;
    testId?: string;
};

const NoGames: FC<Props> = ({ wrapperClassName, testId }) => (
    <div className={classNames("no-game", wrapperClassName)} data-testid={testId}>
        <Translate tid="no_games" />
    </div>
);

export default NoGames;
